var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import ___default from "lodash";
import { DesirableDirection } from "../models/GarModel.js";
import GarConstants from "../models/GarConstants.js";
import { ScorecardRequestState } from "@ane/exp-data/lib/models/expapiv2/AnalysisModels";
const getScorecards = (inputScorecards, data) => {
  const scorecards = [];
  const filteredScorecards = inputScorecards.filter(
    (scorecard) => scorecard.id && scorecard.state === ScorecardRequestState.Completed
  );
  const orderedScorecards = ___default.orderBy(filteredScorecards, (scorecard) => {
    const start = new Date(scorecard.analysisPeriod.startDateTime || "");
    const end = new Date(scorecard.analysisPeriod.endDateTime || "");
    return end.valueOf() - start.valueOf();
  }).reverse();
  const latestScorecard = orderedScorecards ? orderedScorecards[0] : { id: "" };
  filteredScorecards.forEach((scorecard) => {
    var _a, _b, _c, _d;
    if (!!(scorecard == null ? void 0 : scorecard.id) && latestScorecard.id === scorecard.id) {
      scorecards.push({
        scorecardId: parseInt(scorecard.id),
        studyId: parseInt(scorecard.analysisId),
        studyName: data.studyName,
        startDate: ((_b = (_a = scorecard.analysisPeriod) == null ? void 0 : _a.startDateTime) == null ? void 0 : _b.toString()) || "",
        endDate: ((_d = (_c = scorecard.analysisPeriod) == null ? void 0 : _c.endDateTime) == null ? void 0 : _d.toString()) || "",
        controlFlights: ___default.sortBy(data.flights, (flights) => flights.FlightType),
        treatmentFlights: ___default.sortBy(data.flights, (flights) => flights.FlightType).reverse(),
        isOneOff: data.isOneOff,
        triggerFilterFlag: data.userDefinedFilterType,
        triggerFilterCondition: data.userDefinedFilters,
        url: scorecard.scorecardLink || "",
        primaryDataSource: data.primaryDataSource,
        usesMarket: data.markets.length ? true : false
      });
    }
  });
  return scorecards;
};
const getMarketsFilterValues = (analysisFilters) => {
  var _a;
  var mktFilter = analysisFilters.filter((analysisFilter) => analysisFilter.name.toUpperCase() === "MKT");
  return ((_a = mktFilter == null ? void 0 : mktFilter[0]) == null ? void 0 : _a.values) || [];
};
const getUserDefinedFilters = (analysisFilters, templateName) => {
  var _a;
  var userDefinedFilters = analysisFilters.filter((analysisFilter) => analysisFilter.operator.startsWith("Custom"));
  return ((_a = userDefinedFilters == null ? void 0 : userDefinedFilters[0]) == null ? void 0 : _a.values) ? userDefinedFilters[0] : void 0;
};
const getUniqueMetricSets = (data) => {
  const metricSets = data.map((scorecard) => scorecard.primaryDataSource);
  return ___default.uniq(metricSets);
};
const getFilteredMetricCategories = (metricCategories) => {
  const categoryMappings = [];
  const metricCategoryMappings = metricCategories == null ? void 0 : metricCategories.metricCategoryMappings;
  if (metricCategoryMappings !== void 0) {
    metricCategoryMappings.forEach((mapping) => {
      const metricCategories2 = ___default.intersection(mapping.metricCategories, GarConstants.METRIC_CATEGORIES);
      if (metricCategories2.length > 0) {
        mapping.metricCategories = metricCategories2;
        categoryMappings.push(mapping);
      }
    });
  }
  return __spreadProps(__spreadValues({}, metricCategories), {
    metricCategoryMappings: categoryMappings
  });
};
const getMappedMetrics = (result, metricCategoryMappings, hypothesisMetricsData) => {
  const metricValues = [];
  result == null ? void 0 : result.value.forEach((metric) => {
    var _a;
    const matchingMetric = metricCategoryMappings.find((metricCategory) => metricCategory.metricName === metric.metricLabel);
    let tempMetricCategories = [];
    const absolute = ((_a = metric.delta) == null ? void 0 : _a.absolute) || 0;
    const improvement = (absolute > 0 ? DesirableDirection.Up : DesirableDirection.Down) === metric.desirableDirection;
    var metricUsed = false;
    const hypMetric = hypothesisMetricsData == null ? void 0 : hypothesisMetricsData.find((hypothesisMetric) => hypothesisMetric.metric === metric.metricLabel);
    const hypLayout = hypMetric == null ? void 0 : hypMetric.layout.split(".");
    if (hypLayout && hypLayout[0] === metric.scorecardLayout) {
      tempMetricCategories.push(GarConstants.HYPOTHESIS);
      metricUsed = true;
    }
    if (!GarConstants.EXCLUDED_METRIC_NAMES.includes(metric.metricName)) {
      if (matchingMetric) {
        tempMetricCategories.push(...matchingMetric.metricCategories);
        metricUsed = true;
      }
      tempMetricCategories = metric.testResult && metric.testResult.pValue < GarConstants.HIGHLYSTATSIG_PVALTHRESHOLD && !metricUsed ? [GarConstants.OTHER_STRONG_MOVEMENTS] : tempMetricCategories;
      if (tempMetricCategories.length > 0) {
        metricValues.push(__spreadProps(__spreadValues({}, metric), {
          metricCategories: tempMetricCategories,
          improvement
        }));
      }
    }
  });
  return metricValues;
};
const getSegments = (name, value, triggerFilterFlag, filterCondition) => {
  var _a, _b;
  const segment1 = `{ 'Type': 'Standard', 'Level': 1, 'Name': '${name}', 'Value': '${value}'}`;
  const segment2 = `{ 'Type': 'Standard', 'Level': 2, 'Name': 'Aggregate', 'Value': 'Aggregate'}`;
  const segment3 = !!triggerFilterFlag ? `{ 'Type': ${(_a = GarConstants.TRAFFIC_FILTER_CONDITION[triggerFilterFlag]) == null ? void 0 : _a.type}, 'Level': 3, 'Name': '${Object.keys(filterCondition)[0]}', 'Value':${(_b = GarConstants.TRAFFIC_FILTER_CONDITION[triggerFilterFlag]) == null ? void 0 : _b.value}}` : "";
  const segments = `[${segment1}, ${segment2}, ${segment3}]`;
  return segments;
};
const filterSRMEvidences = (data) => {
  const filteredSRMMEvidencesAlerts = data.value.map((alert) => {
    let finalEvidences = alert.evidence;
    if (alert.alertType === GarConstants.ALERT_SAMPLE_RATIO_MISMATCH) {
      finalEvidences = getEvidence(alert.evidence);
    }
    return __spreadProps(__spreadValues({}, alert), {
      evidence: finalEvidences
    });
  });
  return __spreadProps(__spreadValues({}, data), {
    value: filteredSRMMEvidencesAlerts
  });
};
const getEvidence = (srmEvidences) => {
  let evidences = srmEvidences;
  evidences = ___default.orderBy(evidences, (alert) => alert.treatmentSamples + alert.controlSamples, "desc");
  return [evidences[0]];
};
export {
  filterSRMEvidences,
  getEvidence,
  getFilteredMetricCategories,
  getMappedMetrics,
  getMarketsFilterValues,
  getScorecards,
  getSegments,
  getUniqueMetricSets,
  getUserDefinedFilters
};
//# sourceMappingURL=ReducerUtils.js.map
